import { Container, Row, Col } from 'react-bootstrap'
import SliderSlick from 'react-slick'

import LogoCleanFoods from '../assets/images/clientes/logo_cleanfoodsbrasil.png'
import LogoElefantinho from '../assets/images/clientes/logo_elefantinho.png'
import LogoOficina from '../assets/images/clientes/logo_oficina.png'
import LogoMentBlindada from '../assets/images/clientes/logo_mentblindada.png'
import LogoCinenFun from '../assets/images/clientes/logo_cinenfun.png'
import LogoDomMarino from '../assets/images/clientes/logo_dommarino.png'
import LogoEsfiharia from '../assets/images/clientes/logo_esfihariapremium.png'
import LogoAcquaMix from '../assets/images/clientes/logo_acquamix.png'
import LogoArenaChapadao from '../assets/images/clientes/logo_arenachapadao.png'
import LogoAutofest from '../assets/images/clientes/logo_autofest.png'
import LogoAutoPecas from '../assets/images/clientes/logo_autopecas.png'
import LogoAx from '../assets/images/clientes/logo_ax.png'
import LogoBarDoPortugues from '../assets/images/clientes/logo_bardoportugues.png'
import LogoBipLink from '../assets/images/clientes/logo_biplink.png'
import LogoBravaMotos from '../assets/images/clientes/logo_bravamotos.png'
import LogoCaioTragante from '../assets/images/clientes/logo_caiotragante.png'
import LogoCartuchosEAfins from '../assets/images/clientes/logo_cartuchoseafins.png'
import LogoCatto from '../assets/images/clientes/logo_catto.png'
import LogoChiqueirinho from '../assets/images/clientes/logo_chiqueirinho.png'
import LogoCivilita from '../assets/images/clientes/logo_civilita.png'
import LogoClaudioMassad from '../assets/images/clientes/logo_claudiomassad.png'
import LogoCleanFoodsCT from '../assets/images/clientes/logo_cleanfoodsct.png'
import LogoCleveri from '../assets/images/clientes/logo_cleveri.png'
import LogoDjaseg from '../assets/images/clientes/logo_djaseg.png'
import LogoDoceriaNobre from '../assets/images/clientes/logo_docerianobre.png'
import LogoEdan from '../assets/images/clientes/logo_edan.png'
import LogoErikBreslay from '../assets/images/clientes/logo_erikbreslay.png'
import LogoEvergreen from '../assets/images/clientes/logo_evergreen.png'
import LogoFalcao from '../assets/images/clientes/logo_falcao.png'
import LogoGastro from '../assets/images/clientes/logo_gastro.png'
import LogoHidrus from '../assets/images/clientes/logo_hidrus.png'
import LogoJet from '../assets/images/clientes/logo_jet.png'
import LogoJoanaDarc from '../assets/images/clientes/logo_joanadarc.png'
import LogoLemoncello from '../assets/images/clientes/logo_lemoncello.png'
import LogoLMVet from '../assets/images/clientes/logo_lmvet.png'
import LogoMarathon from '../assets/images/clientes/logo_marathon.png'
import LogoMediodontus from '../assets/images/clientes/logo_mediodontus.png'
import LogoMundoPet from '../assets/images/clientes/logo_mundopet.png'
import LogoPanobianco from '../assets/images/clientes/logo_panobianco.png'
import LogoQuintaNossa from '../assets/images/clientes/logo_quintanossa.png'
import LogoSecaEModela from '../assets/images/clientes/logo_secaemodela.png'
import LogoSerginhoMotos from '../assets/images/clientes/logo_serginhomotos.png'
import LogoSumiai from '../assets/images/clientes/logo_sumiai.png'
import LogoTigrao from '../assets/images/clientes/logo_tigrao.png'
import LogoTioPetisco from '../assets/images/clientes/logo_tiopetisco.png'
import LogoTurrini from '../assets/images/clientes/logo_turrini.png'
import LogoUscopao from '../assets/images/clientes/logo_uscopao.png'
import LogoVeronez from '../assets/images/clientes/logo_veronez.png'
import LogoVilla from '../assets/images/clientes/logo_villa.png'

function Slider({ title }) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
        }
      }
    ]
  }

  const elements = [
    {
      image: LogoCleanFoods,
      description: 'Agência Black Star'
    },
    {
      image: LogoElefantinho,
      description: 'Agência Black Star'
    },
    {
      image: LogoOficina,
      description: 'Agência Black Star'
    },
    {
      image: LogoMentBlindada,
      description: 'Agência Black Star'
    },
    {
      image: LogoCinenFun,
      description: 'Agência Black Star'
    },
    {
      image: LogoDomMarino,
      description: 'Agência Black Star'
    },
    {
      image: LogoEsfiharia,
      description: 'Agência Black Star'
    },
    {
      image: LogoAcquaMix,
      description: 'Agência Black Star'
    },
    {
      image: LogoArenaChapadao,
      description: 'Agência Black Star'
    },
    {
      image: LogoAutofest,
      description: 'Agência Black Star'
    },
    {
      image: LogoAutoPecas,
      description: 'Agência Black Star'
    },
    {
      image: LogoAx,
      description: 'Agência Black Star'
    },
    {
      image: LogoBarDoPortugues,
      description: 'Agência Black Star'
    },
    {
      image: LogoBipLink,
      description: 'Agência Black Star'
    },
    {
      image: LogoBravaMotos,
      description: 'Agência Black Star'
    },
    {
      image: LogoCaioTragante,
      description: 'Agência Black Star'
    },
    {
      image: LogoCartuchosEAfins,
      description: 'Agência Black Star'
    },
    {
      image: LogoCatto,
      description: 'Agência Black Star'
    },
    {
      image: LogoChiqueirinho,
      description: 'Agência Black Star'
    },
    {
      image: LogoCivilita,
      description: 'Agência Black Star'
    },
    {
      image: LogoClaudioMassad,
      description: 'Agência Black Star'
    },
    {
      image: LogoCleanFoodsCT,
      description: 'Agência Black Star'
    },
    {
      image: LogoCleveri,
      description: 'Agência Black Star'
    },
    {
      image: LogoDjaseg,
      description: 'Agência Black Star'
    },
    {
      image: LogoDoceriaNobre,
      description: 'Agência Black Star'
    },
    {
      image: LogoEdan,
      description: 'Agência Black Star'
    },
    {
      image: LogoErikBreslay,
      description: 'Agência Black Star'
    },
    {
      image: LogoEvergreen,
      description: 'Agência Black Star'
    },
    {
      image: LogoFalcao,
      description: 'Agência Black Star'
    },
    {
      image: LogoGastro,
      description: 'Agência Black Star'
    },
    {
      image: LogoHidrus,
      description: 'Agência Black Star'
    },
    {
      image: LogoJet,
      description: 'Agência Black Star'
    },
    {
      image: LogoJoanaDarc,
      description: 'Agência Black Star'
    },
    {
      image: LogoLemoncello,
      description: 'Agência Black Star'
    },
    {
      image: LogoLMVet,
      description: 'Agência Black Star'
    },
    {
      image: LogoMarathon,
      description: 'Agência Black Star'
    },
    {
      image: LogoMediodontus,
      description: 'Agência Black Star'
    },
    {
      image: LogoMundoPet,
      description: 'Agência Black Star'
    },
    {
      image: LogoPanobianco,
      description: 'Agência Black Star'
    },
    {
      image: LogoQuintaNossa,
      description: 'Agência Black Star'
    },
    {
      image: LogoSecaEModela,
      description: 'Agência Black Star'
    },
    {
      image: LogoSerginhoMotos,
      description: 'Agência Black Star'
    },
    {
      image: LogoSumiai,
      description: 'Agência Black Star'
    },
    {
      image: LogoTigrao,
      description: 'Agência Black Star'
    },
    {
      image: LogoTioPetisco,
      description: 'Agência Black Star'
    },
    {
      image: LogoTurrini,
      description: 'Agência Black Star'
    },
    {
      image: LogoUscopao,
      description: 'Agência Black Star'
    },
    {
      image: LogoVeronez,
      description: 'Agência Black Star'
    },
    {
      image: LogoVilla,
      description: 'Agência Black Star'
    }
  ]

  return (
    <Container className='text-center'>
      <Row>
        <Col>
          <span className='cloister-black' style={{ color: '#FFF', fontSize: '60px' }}>{ title }</span>
          <SliderSlick {...settings}>
            {elements.map((image, i) => (
              <div key={i}>
                <img src={image.image} alt={`Slide ${i}`} style={{ width: "100%", height: "auto" }} />
              </div>
            ))}
          </SliderSlick>
        </Col>
      </Row>
    </Container>
  )
}

export default Slider